import { SVGAttributes, ReactElement } from 'react'

type Props = SVGAttributes<SVGElement>

function CobaltLogo(props: Props): ReactElement {
    const { fill } = props
    const fillColor = fill ?? '#000'

    return (
        <svg
            viewBox="0 0 338 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_2872_4515)">
                <path
                    d="M141.361 71.1212C136.071 71.1212 131.565 69.9737 127.842 67.6783C124.12 65.3587 121.266 62.1356 119.283 58.0091C117.323 53.8825 116.344 49.0966 116.344 43.6515C116.344 38.2064 117.323 33.4205 119.283 29.2939C121.266 25.1675 124.12 21.9565 127.842 19.6612C131.565 17.3416 136.071 16.1818 141.361 16.1818C147.459 16.1818 152.504 17.72 156.495 20.7966C160.512 23.8733 163.304 28.0121 164.871 33.213L157.083 35.3007C156.055 31.6137 154.218 28.7202 151.573 26.6203C148.952 24.5204 145.549 23.4704 141.361 23.4704C137.613 23.4704 134.492 24.3128 131.994 25.9977C129.496 27.6825 127.609 30.0388 126.336 33.0665C125.087 36.0943 124.463 39.6227 124.463 43.6515C124.438 47.6804 125.051 51.2087 126.299 54.2365C127.572 57.2642 129.459 59.6205 131.957 61.3054C134.479 62.9902 137.613 63.8326 141.361 63.8326C145.549 63.8326 148.952 62.7826 151.573 60.6827C154.218 58.5584 156.055 55.6649 157.083 52.0024L164.871 54.09C163.304 59.2909 160.512 63.4297 156.495 66.5063C152.504 69.583 147.459 71.1212 141.361 71.1212Z"
                    fill={fillColor}
                />
                <path
                    d="M188.485 71.1212C184.518 71.1212 181.077 70.23 178.163 68.4476C175.248 66.665 172.995 64.2111 171.404 61.0856C169.837 57.9357 169.052 54.3097 169.052 50.2076C169.052 46.081 169.86 42.455 171.477 39.3296C173.094 36.1798 175.359 33.738 178.273 32.0044C181.188 30.2463 184.591 29.3673 188.485 29.3673C192.453 29.3673 195.894 30.2585 198.808 32.0409C201.722 33.8234 203.976 36.2774 205.567 39.4028C207.159 42.5283 207.955 46.1299 207.955 50.2076C207.955 54.3342 207.146 57.9724 205.53 61.1222C203.939 64.2477 201.686 66.7017 198.771 68.4841C195.857 70.2422 192.428 71.1212 188.485 71.1212ZM188.485 63.9059C192.282 63.9059 195.11 62.6361 196.971 60.0967C198.857 57.5329 199.8 54.2365 199.8 50.2076C199.8 46.081 198.844 42.7846 196.934 40.3185C195.049 37.8279 192.232 36.5826 188.485 36.5826C185.914 36.5826 183.795 37.1686 182.13 38.3407C180.465 39.4883 179.228 41.0877 178.42 43.1388C177.612 45.1654 177.208 47.5217 177.208 50.2076C177.208 54.3586 178.163 57.6793 180.073 60.17C181.983 62.6606 184.788 63.9059 188.485 63.9059Z"
                    fill={fillColor}
                />
                <path
                    d="M232.958 71.1212C229.162 71.1212 225.978 70.2056 223.407 68.3742C220.836 66.5185 218.889 64.0158 217.567 60.8658C216.243 57.716 215.583 54.1632 215.583 50.2076C215.583 46.252 216.231 42.6992 217.53 39.5493C218.852 36.3995 220.787 33.9211 223.334 32.1142C225.905 30.2829 229.064 29.3673 232.811 29.3673C236.533 29.3673 239.742 30.2829 242.436 32.1142C245.154 33.9211 247.248 36.3995 248.718 39.5493C250.187 42.6748 250.922 46.2276 250.922 50.2076C250.922 54.1632 250.187 57.7282 248.718 60.9025C247.273 64.0523 245.203 66.5429 242.509 68.3742C239.839 70.2056 236.656 71.1212 232.958 71.1212ZM214.296 70.0225V17.2805H222.011V41.5638H221.13V70.0225H214.296ZM231.893 64.1989C234.342 64.1989 236.362 63.5763 237.954 62.331C239.57 61.0856 240.77 59.413 241.554 57.3131C242.362 55.1888 242.766 52.8203 242.766 50.2076C242.766 47.6194 242.362 45.2752 241.554 43.1753C240.77 41.0754 239.558 39.4028 237.917 38.1575C236.276 36.9122 234.183 36.2896 231.636 36.2896C229.236 36.2896 227.252 36.8757 225.684 38.0476C224.142 39.2197 222.991 40.8557 222.232 42.9556C221.497 45.0555 221.13 47.4728 221.13 50.2076C221.13 52.9424 221.497 55.3597 222.232 57.4596C222.966 59.5596 224.129 61.2077 225.721 62.4042C227.314 63.6007 229.37 64.1989 231.893 64.1989Z"
                    fill={fillColor}
                />
                <path
                    d="M268.543 71.1212C265.605 71.1212 263.143 70.584 261.16 69.5097C259.176 68.4109 257.669 66.9703 256.641 65.1877C255.636 63.3809 255.134 61.4031 255.134 59.2544C255.134 57.2521 255.49 55.494 256.2 53.9801C256.91 52.4663 257.963 51.1843 259.359 50.1344C260.755 49.06 262.47 48.1932 264.502 47.5339C266.265 47.0211 268.261 46.5694 270.49 46.1787C272.719 45.7881 275.057 45.4218 277.507 45.0799C279.98 44.7381 282.429 44.3962 284.853 44.0543L282.061 45.5927C282.11 42.4917 281.449 40.1964 280.077 38.707C278.731 37.193 276.405 36.4362 273.098 36.4362C271.016 36.4362 269.106 36.9245 267.367 37.9012C265.628 38.8534 264.417 40.4406 263.73 42.6626L256.567 40.465C257.547 37.071 259.408 34.3728 262.151 32.3706C264.918 30.3684 268.592 29.3673 273.171 29.3673C276.722 29.3673 279.808 29.9777 282.429 31.1986C285.073 32.3951 287.008 34.2996 288.233 36.9122C288.87 38.2064 289.261 39.5737 289.409 41.0144C289.555 42.455 289.629 44.0055 289.629 45.6659V70.0225H282.832V60.9757L284.156 62.1478C282.515 65.1756 280.42 67.4342 277.873 68.9236C275.351 70.3888 272.241 71.1212 268.543 71.1212ZM269.902 64.8581C272.082 64.8581 273.955 64.4797 275.523 63.7227C277.09 62.9413 278.352 61.9524 279.306 60.756C280.262 59.5596 280.885 58.3143 281.179 57.0201C281.596 55.8481 281.829 54.5295 281.878 53.0645C281.952 51.5994 281.988 50.4273 281.988 49.5483L284.486 50.464C282.061 50.8303 279.857 51.1599 277.873 51.4529C275.889 51.7459 274.09 52.0389 272.474 52.332C270.881 52.6005 269.462 52.9302 268.212 53.3209C267.159 53.6871 266.216 54.1267 265.383 54.6394C264.575 55.1522 263.927 55.7748 263.436 56.5074C262.971 57.2398 262.739 58.1311 262.739 59.181C262.739 60.2066 262.996 61.1589 263.51 62.0379C264.024 62.8925 264.808 63.5763 265.862 64.089C266.915 64.6018 268.261 64.8581 269.902 64.8581Z"
                    fill={fillColor}
                />
                <path
                    d="M298.209 70.0225V16.1818H305.886V70.0225H298.209Z"
                    fill={fillColor}
                />
                <path
                    d="M337.926 70.0225C335.428 70.5108 332.979 70.7184 330.579 70.6451C328.179 70.5718 326.036 70.1079 324.151 69.2533C322.265 68.3986 320.844 67.0557 319.889 65.2244C319.032 63.5884 318.567 61.928 318.493 60.2432C318.444 58.534 318.42 56.605 318.42 54.4563V19.4781H326.134V54.09C326.134 55.6772 326.147 57.0567 326.171 58.2288C326.219 59.4008 326.477 60.3898 326.942 61.1956C327.824 62.7094 329.22 63.5763 331.13 63.796C333.065 63.9914 335.33 63.9059 337.926 63.5396V70.0225ZM310.816 36.6192V30.466H337.926V36.6192H310.816Z"
                    fill={fillColor}
                />
                <rect
                    y="-0.130566"
                    width="88"
                    height="88"
                    rx="14"
                    fill="#4A2DFF"
                />
                <rect
                    y="-0.130566"
                    width="88"
                    height="88"
                    rx="14"
                    fill="url(#paint0_linear_2872_4515)"
                    fillOpacity="0.1"
                    style={{ mixBlendMode: 'multiply' }}
                />
                <rect
                    y="-0.130566"
                    width="88"
                    height="88"
                    rx="14"
                    fill="url(#paint1_linear_2872_4515)"
                    fillOpacity="0.2"
                    style={{ mixBlendMode: 'screen' }}
                />
                <g filter="url(#filter0_d_2872_4515)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M70.2288 17.8588C71.8454 19.4693 72.4779 21.821 71.8874 24.025L60.1719 67.7476C59.2607 71.1484 55.7651 73.1667 52.3642 72.2554C48.9634 71.3441 46.9452 67.8485 47.8564 64.4477L56.7015 31.4375L23.0499 40.435C19.6525 41.3592 16.1493 39.3542 15.2251 35.9569C14.301 32.5596 16.3059 29.0563 19.7033 28.1322L64.0563 16.2237C66.2582 15.6247 68.6123 16.2484 70.2288 17.8588ZM51.6833 36.4775L44.333 63.6833C43.4217 67.0841 39.9262 69.1022 36.5253 68.191C33.1245 67.2797 31.1063 63.7842 32.0176 60.3834L33.5306 54.6289L27.5623 56.1527C24.1649 57.0768 20.957 54.9865 20.0329 51.5892C19.1087 48.1919 20.8183 44.774 24.2157 43.8499L51.6833 36.4775Z"
                        fill={fillColor}
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_2872_4515"
                    x="9"
                    y="15"
                    width="69.1047"
                    height="68.4742"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="3" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="multiply"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2872_4515"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2872_4515"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2872_4515"
                    x1="44"
                    y1="87.8694"
                    x2="44"
                    y2="-0.130566"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2872_4515"
                    x1="44"
                    y1="87.8694"
                    x2="44"
                    y2="-0.130566"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <clipPath id="clip0_2872_4515">
                    <rect width="338" height="88" fill={fillColor} />
                </clipPath>
            </defs>
        </svg>
    )
}

export default CobaltLogo
